.faqWrapper {
  margin: 40px 0 64px 0;
  padding: 0 20px;

  .faqTitle {
    color: #231e19;
    text-align: center;
    font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
      sans-serif);
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 34px;
    letter-spacing: -0.4px;
  }

  .faqItems {
    margin-top: 19px;
  }

  .faqItem {
    position: relative;
    border-bottom: 1px solid var(--ed-border, #dedee0);

    &:last-child {
      border-bottom: none;
    }
  }

  .faqItem:nth-child(1) {
    padding: 0 0 24px 0;
  }

  .faqItem:nth-child(2) {
    padding: 24px 0;
  }

  .faqItem:nth-child(3) {
    padding: 24px 0 0 0;
  }

  .faqItemQuestion {
    position: relative;
    color: #231e19;
    font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
      sans-serif);
    font-size: 19px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.076px;
    padding-right: 24px;
    cursor: pointer;
    user-select: none;

    &::after {
      content: '';
      position: absolute;
      top: 3px;
      right: 0;
      width: 16px;
      height: 16px;
      background: url('./img/arrow2.svg') no-repeat center;
      background-size: contain;
    }
  }

  .faqItemAnswer {
    display: none;
    margin-top: 8px;
    color: #231e19;
    font-family: 'SF Pro', -apple-system, 'Roboto', sans-serif;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.4px;
  }

  .faqItem.active {
    .faqItemAnswer {
      display: block;
    }

    .faqItemQuestion {
      &::after {
        background: url('./img/arrow1.svg') no-repeat center;

        :global(.k9GreenTheme) & {
          background-image: url('./img/arrow1Green.svg');
        }
      }
    }
  }
}

.theme1 {
  margin-top: 62px;
  padding: 0;

  .faqTitle,
  .faqItemQuestion,
  .faqItemAnswer {
    color: #fffbf2;
  }

  .faqItemQuestion {
    &::after {
      filter: brightness(0) invert(1);
    }
  }
}

// Dark mode
:global(body.dark) {
  .faqTitle,
  .faqItemQuestion,
  .faqItemAnswer {
    color: #ffffff;
  }

  .faqItem {
    border-color: var(--ed-border, #3e3c3a);
  }
}
